import { Button } from "rsuite";
import styled, { css } from "styled-components";

const TableActionButton = styled(Button)`
    && {
        background: transparent;
        color: var(--color-button);
        border: 1px solid var(--color-button);
        border-radius: 4px;
        padding: 0.25rem 0.5rem;
        display: inline-flex;
        align-items: center;
        /* gap: 0.3rem; */
        transition: background-color 0.2s, color 0.2s;

        height: 24px;
        margin-top: -3px;
        gap: 0.5rem;
        ${props => props.mr ? css`
            margin-right: ${props.mr ?? 0}px;
        ` : css`
            margin-right: 0;
        `}
        ${props => props.small && css`
            svg.rs-icon {
                font-size: 14px;
            }
            span {
                font-size: 13px;
            }
        `}
    }

    &&.rs-btn.rs-btn-disabled {
        border: 1px solid var(--color-button-hover);
        color: var(--color-button-hover);
    }

    &&.rs-btn:hover {
        background-color: var(--color-button);
        color: var(--color-text);
    }

    &&.rs-btn:focus {
        color: var(--color-button);
    }

    &&.rs-btn:hover:focus {
        color: var(--color-text);
    }

    &&.rs-btn.rs-btn-disabled:hover {
        background-color: var(--color-button-hover);
        color: var(--color-text-dark);
    }

    &&.rs-btn.rs-btn-disabled:focus {
        color: var(--color-text-dark);
    }

    &&.rs-btn:hover:focus {
        color: var(--color-text-dark);
    }
`;

export default TableActionButton;